import {Component, Input } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-storyboard-progress-bar',
  templateUrl: './storyboard-progress-bar.component.html',
  styleUrls: ['./storyboard-progress-bar.component.scss']
})
export class StoryboardProgressBarComponent {
  @Input() progressWidth: string = '0%';
  
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/storyboard-publish/storyboard-progress-bar/storyboard-progress-bar.component.ts